import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import {Translation, Translator} from '@morningtrain/react-translations'
import Widget from 'widgets/Widget'
import {Collection, ForEachModel} from '@morningtrain/react-resources'
import {StaticFilter} from '@morningtrain/react-filters'
import {SelectedDepartmentFilter} from 'support/filters'
import {Can} from '@morningtrain/react-auth'
import WithModelValue from 'support/utilities/WithModelValue'
import OnClickPipeline from 'support/pipelines/OnClickPipeline'
import {MountSmartviewOnPipe} from '@morningtrain/react-smartviews'
import UserProfileSmartview from 'widgets/smartviews/users/UserProfileSmartview'

export default function EmployeeShiftsDashboardWidget({category = 'kitchen'}) {
    const icon = category === 'kitchen' ? <UI.Icons.Chef/> : <UI.Icons.Plates/>
    const format = 'YYYY-MM-DD HH:mm:ss'

    return (
        <Can permission='api.dashboard.employee_shifts'>
            <Widget>
                <Translator namespace='dashboard.employee_shifts'>
                    <UI.Card>
                        <UI.CardHeader>
                            <UI.Text size='base'>
                                <UI.WithIcon icon={icon} size={6} space='space-x-4'>
                                    <Translation name={`titles.${category}`}/>
                                </UI.WithIcon>
                            </UI.Text>
                        </UI.CardHeader>
                        <Collection resourceName='dashboard' operationName='employee_shifts'
                                    operationContext={{category}}>
                            <SelectedDepartmentFilter/>
                            <StaticFilter name='category' value={category}/>
                            <UI.VerticalList>
                                <ForEachModel>
                                    <OnClickPipeline trigger={(
                                        <UI.SpaceBetween className='cursor-pointer'>
                                            <WithModelValue name='is_working'>
                                                {isWorking => (
                                                    <UI.EmployeeInfo
                                                        active={isWorking}
                                                        avatar={<Displays.Image name='avatar'/>}
                                                        title={<Displays.Text name='name'/>}
                                                        text={<Displays.Text name='employment_name'/>}
                                                        badges={<Displays.Badges big/>}
                                                    />
                                                )}
                                            </WithModelValue>
                                            <div className='flex-shrink-0'>
                                                <UI.WithSubtitle subtitle={(
                                                    <UI.Text block align='right'>
                                                        <Displays.Duration name='duration'/>
                                                    </UI.Text>
                                                )}
                                                >
                                                    <UI.Text weight='medium'>
                                                        <Displays.Date name='start_at' dateFormat='HH:mm'
                                                                       parseFormat={format}/>
                                                        <span> - </span>
                                                        <Displays.Date name='end_at' dateFormat='HH:mm'
                                                                       parseFormat={format}/>
                                                    </UI.Text>
                                                </UI.WithSubtitle>
                                            </div>
                                        </UI.SpaceBetween>
                                    )}
                                    >
                                        <WithModelValue name='id'>
                                            {id => (
                                                <MountSmartviewOnPipe smartview={<UserProfileSmartview id={id}/>}
                                                                      replace={false}/>
                                            )}
                                        </WithModelValue>
                                    </OnClickPipeline>
                                </ForEachModel>
                            </UI.VerticalList>
                        </Collection>
                    </UI.Card>
                </Translator>
            </Widget>
        </Can>
    )
}
